import Imatge from 'components/corporatiu/Imatge';
import styles from './impactesmarato.module.scss';

const ImpactesMarato = ({ texts }) => {
    return (
        <div className={styles.impactesMarato}>
            <div className={styles.header}>
                <h2>{texts.headerTitle}</h2>
                <p>{texts.headerSubtitle}</p>
            </div>
            <div className={styles.seccio}>
                <div className={styles.imatgeWrapper}>
                    <Imatge
                        src='https://statics.3cat.cat/recursos/marato/img/icn-solidaritat-impactes.png'
                        width='98'
                        height='98'
                        alt={texts.seccio1Alt}
                    />
                </div>
                <div className={styles.textWrapper}>
                    <p className={styles.seccioTitol}>{texts.seccio1Title}</p>
                    <div className={styles.dades}>
                        <div>
                            <p className={styles.textHighlight}>{texts.seccio1Dada1}</p>
                            <p className={styles.subtitle}>{texts.seccio1Dada1Subtitle}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.seccio}>
                <div className={styles.imatgeWrapper}>
                    <Imatge
                        src='https://statics.3cat.cat/recursos/marato/img/icn-investigacio-impactes.png'
                        width='98'
                        height='98'
                        alt={texts.seccio2Alt}
                    />
                </div>
                <div className={styles.textWrapper}>
                    <p className={styles.seccioTitol}>{texts.seccio2Title}</p>
                    <div className={styles.dades}>
                        <div>
                            <p className={styles.textHighlight}>{texts.seccio2Dada1}</p>
                            <p className={styles.subtitle}>{texts.seccio2Dada1Subtitle}</p>
                        </div>
                        <div>
                            <p className={styles.textHighlight}>{texts.seccio2Dada2}</p>
                            <p className={styles.subtitle}>{texts.seccio2Dada2Subtitle}</p>
                        </div>
                        <div>
                            <p className={styles.textHighlight}>{texts.seccio2Dada3}</p>
                            <p className={styles.subtitle}>{texts.seccio2Dada3Subtitle}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.seccio}>
                <div className={styles.imatgeWrapper}>
                    <Imatge
                        src='https://statics.3cat.cat/recursos/marato/img/icn-talent-impactes.png'
                        width='98'
                        height='98'
                        alt={texts.seccio3Alt}
                    />
                </div>
                <div className={styles.textWrapper}>
                    <p className={styles.seccioTitol}>{texts.seccio3Title}</p>
                    <div className={styles.dades}>
                        <div>
                            <p className={styles.textHighlight}>{texts.seccio3Dada1}</p>
                            <p className={styles.subtitle}>{texts.seccio3Dada1Subtitle}</p>
                        </div>
                        <div>
                            <p className={styles.textHighlight}>{texts.seccio3Dada2}</p>
                            <p className={styles.subtitle}>{texts.seccio3Dada2Subtitle}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.seccio}>
                <div className={styles.imatgeWrapper}>
                    <Imatge
                        src='https://statics.3cat.cat/recursos/marato/img/icn-sensibilitza-impactes.png'
                        width='98'
                        height='98'
                        alt={texts.seccio4Alt}
                    />
                </div>
                <div className={styles.textWrapper}>
                    <p className={styles.seccioTitol}>{texts.seccio4Title}</p>
                    <div className={styles.dades}>
                        <div>
                            <p className={styles.textHighlight}>{texts.seccio4Dada1}</p>
                            <p className={styles.subtitle}>{texts.seccio4Dada1Subtitle}</p>
                        </div>
                        <div>
                            <p className={styles.textHighlight}>{texts.seccio4Dada2}</p>
                            <p className={styles.subtitle}>{texts.seccio4Dada2Subtitle}</p>
                        </div>
                        <div>
                            <p className={styles.textHighlight}>{texts.seccio4Dada3}</p>
                            <p className={styles.subtitle}>{texts.seccio4Dada3Subtitle}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.seccio}>
                <div className={styles.imatgeWrapper}>
                    <Imatge
                        src='https://statics.3cat.cat/recursos/marato/img/icn-mobilitzacio-impactes.png'
                        width='98'
                        height='98'
                        alt={texts.seccio5Alt}
                    />
                </div>
                <div className={styles.textWrapper}>
                    <p className={styles.seccioTitol}>{texts.seccio5Title}</p>
                    <div className={styles.dades}>
                        <div>
                            <p className={styles.textHighlight}>{texts.seccio5Dada1}</p>
                            <p className={styles.subtitle}>{texts.seccio5Dada1Subtitle}</p>
                        </div>
                        <div>
                            <p className={styles.textHighlight}>{texts.seccio5Dada2}</p>
                            <p className={styles.subtitle}>
                                {texts.seccio5Dada2Subtitle}
                                <span>{texts.seccio5Dada2Highlight}</span>
                                {texts.seccio5Dada2Suffix}
                            </p>
                        </div>
                        <div>
                            <p className={styles.textHighlight}>{texts.seccio5Dada3}</p>
                            <p className={styles.subtitle}>{texts.seccio5Dada3Subtitle}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImpactesMarato;
